import { Button, Card, Modal } from '@presentation/components';
import type { FC } from 'react';
import { useTranslation } from '@presentation/utils';
import * as Styled from './styled';
import type { PrebookingWarningModalProps } from './types';

export * from './types';
export * from './components/PrebookingWarning';

export const PrebookingWarningModal: FC<PrebookingWarningModalProps> = (props) => {
  const { modal, onConfirm, proWarning, workerServiceWarning } = props;

  const { translate } = useTranslation();

  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        {proWarning && (
          <>
            <Styled.Label>{translate('common.modals.preBooking.title')}</Styled.Label>
            <Styled.PreBookingWarning dangerouslySetInnerHTML={{ __html: proWarning }} />
          </>
        )}
        {workerServiceWarning && (
          <>
            <Styled.Label>{translate('common.modals.preBooking.workerTitle')}</Styled.Label>
            <Styled.PreBookingWarning
              dangerouslySetInnerHTML={{
                __html: workerServiceWarning,
              }}
            />
          </>
        )}
        <Button color="blue" onClick={onConfirm}>
          {translate('common.buttons.iAcccept')}
        </Button>
      </Card>
    </Modal>
  );
};
